import { getAppType } from "utils/helper";

export const mapBEStepstoMatchFE = (step: number): number => {
  const stepsmap: any = {
    5: 1,
    6: 2,
    7: 3,
  };
  return stepsmap[step];
};

export const mapFEStepstoMatchBE = (step: number): number => {
  const stepsmap: any = {
    1: 5,
    2: 6,
    3: 7,
  };
  return stepsmap[step];
};

export const peoOptions = [
  { value: "TriNet", description: "TriNet" },
  { value: "ADP Totalsource", description: "ADP Totalsource" },
  { value: "Insperity", description: "Insperity" },
  { value: "Oasis", description: "Oasis" },
  { value: "Coadvantage", description: "Coadvantage" },
  { value: "Extensis", description: "Extensis" },
  { value: "Paychex", description: "Paychex" },
  { value: "Engage", description: "Engage" },
  { value: "Prestige", description: "Prestige" },
  { value: "HROi", description: "HROi" },
  { value: "Other", description: "Other" },
];

export const validRenewalDate = (date: string) => {
  const isHealthInsuranceUpsellApp = getAppType() === "HEALTH_INSURANCE_UPSELL";
  const renewdaleDateLimit = isHealthInsuranceUpsellApp ? 60 : 90;
  const renewalDate = new Date(date);
  const today = new Date();
  const beforeLimitDays = new Date(
    new Date().setDate(today.getDate() - renewdaleDateLimit)
  );
  const afterLimitDays = new Date(
    new Date().setDate(today.getDate() + renewdaleDateLimit)
  );

  return renewalDate < beforeLimitDays || renewalDate > afterLimitDays;
};
